import * as i0 from '@angular/core';
import { Optional, Self, Directive, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TUI_VALUE_ACCESSOR } from '@taiga-ui/legacy/tokens';
import { identity } from 'rxjs';

const TUI_VALUE_ACCESSOR_PROVIDER = {
    provide: TUI_VALUE_ACCESSOR,
    deps: [[new Optional(), new Self(), NG_VALUE_ACCESSOR]],
    useFactory: identity,
};

class TuiValueAccessorDirective {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiValueAccessorDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "16.2.12", type: TuiValueAccessorDirective, selector: "[tuiValueAccessor]", providers: [TUI_VALUE_ACCESSOR_PROVIDER], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiValueAccessorDirective, decorators: [{
            type: Directive,
            args: [{
                    standalone: false,
                    selector: '[tuiValueAccessor]',
                    providers: [TUI_VALUE_ACCESSOR_PROVIDER],
                }]
        }] });

class TuiValueAccessorModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiValueAccessorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: TuiValueAccessorModule, declarations: [TuiValueAccessorDirective], exports: [TuiValueAccessorDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiValueAccessorModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: TuiValueAccessorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TuiValueAccessorDirective],
                    exports: [TuiValueAccessorDirective],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_VALUE_ACCESSOR_PROVIDER, TuiValueAccessorDirective, TuiValueAccessorModule };
